var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery-area"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-12"},[_c('div',{staticClass:"gallery-wrapper"},[_vm._m(0),_c('vue-picture-swipe',{attrs:{"items":_vm.items,"options":{
              shareEl: false,
              zoomEl: false,
              fullscreenEl: false,
              bgOpacity:0.85
            }}})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"title"},[_c('span',[_vm._v("@WATCHSTORE")]),_vm._v(" Gallery Image ")])}]

export { render, staticRenderFns }